import '../styles/ObshtaInformaciq.css'
import DecorativeStripeFull from "../web_elements/decorative_stripe_full.png";
import React from "react";
function ObshtaInformaciq() {
    return (
        <section className="info-sections">
            <div>
                <strong>Интериорен дизайн и планиране</strong>
                <p>
                    Предлагаме широк спектър от строителни ремонти за вече построени сгради,<br></br>
                    които се нуждаят от обновяване и укрепване.
                </p>
                <strong>Оптимизация на пространствата:</strong>
                <p>
                    Разпределение на зони и<br></br>
                    помещения, съобразено с Вашите нужди, за максимална ефективност и комфорт.
                </p>
                <strong>Дизайн на вътрешни преградни стени и елементи:</strong>
                <p>
                    Проектиране
                    на прегради, бар плотове, вградени килери и други неносещи конструкции.
                </p>
                <strong>Избор на материали и облицовки:</strong>
                <p>
                    Предлагане на подходящи
                    стенни и подови покрития – плочки, паркет, ламинат и декоративни облицовки,
                    които отговарят на изискванията за стил и устойчивост.
                </p>
                <strong>Преустройство на помещение:</strong>
                <p>
                    Отваряне или затваряне на
                    пространства, планиране на нови проходи и прозорци, съобразено с техническите
                    възможности.
                </p>
                <strong>Фасадно оформление:</strong>
                <p>
                    Избор на външни материали и цветови
                    комбинации за реновиране на фасадата на сградата.
                </p>
                <strong>Визуализация и концепции:</strong>
                <p>
                    Подготовка на визуални проекти
                    за по-добра представа за бъдещия интериор или екстериор.
                </p>
                <img src={DecorativeStripeFull}
                     alt="">
                </img>
                <p id="stroitelstvo">Строителство и довършителни работи</p>
                <p></p>
                <p>
                Предлагаме широк спектър от строителни ремонти за вече построени сгради,
                    които се нуждаят от обновяване и укрепване:
                </p>
                <strong>Ремонт и укрепване на покриви:</strong>
                <p>
                    Подмяна на покривни
                    конструкции, полагане на нови керемиди, хидроизолация и изграждане на
                    водоотвеждащи системи.
                </p>
                <strong>Укрепване на стени:</strong>
                <p>
                    Реконструкция на носещи стени, подмяна
                    на преградни стени и обновяване на фасади с мазилки, облицовки и други
                    материали.
                </p>
                <strong>Реновация на основи и подове:</strong>
                <p>
                    Стабилизиране на основи при
                    слягания, полагане на нови подови настилки (бетон, плочки, паркет) и
                    подобряване на изолацията.
                </p>
                <strong>Промяна на пространствата:</strong>
                <p>
                    Отваряне на проходи, изграждане
                    на нови прозорци, затваряне на тераси и изграждане на допълнителни
                    конструкции.
                </p>
                <strong>Топлоизолация и саниране:</strong>
                <p>
                    Полагане на изолация на стени,
                    тавани и подове, както и защита на фасади от влага и атмосферни влияния.
                </p>
                <strong>Довършителни работи:</strong>
                <p>
                    Шпакловане, боядисване, монтаж на
                    корнизи, первази и декоративни елементи.
                </p>
            </div>
        </section>
    );
}

export default ObshtaInformaciq